export default "__VITE_PUBLIC_ASSET__a274cc89__"